import { useUpdateSoftwareLinkMutation } from "../../api/api-hooks";
import { SoftwareLinksForm } from "./linksTypes";

const useSoftwareLinksUpdater = () => {
  const [editLink] = useUpdateSoftwareLinkMutation();
  return (item: SoftwareLinksForm, id: number) => {
    return editLink({
      id: id,
      updateSoftwareLinkDto: {
        id: id,
        name: item.name,
        link: item.link,
        softwareId: item.software?.id,
      },
    });
  };
};

export default useSoftwareLinksUpdater;
